import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toggleModal } from '../../../../reducers/modalReducer.js';
import CoreWorkspaceButton from '../../../../components/logged_in/CoreWorkspaceButton.js';
import SectionTitle from './components/SectionTitle.js';
import Button from '../../../../components/common/Button/index.jsx';
import AdvisorCarousel from './components/AdvisorCarousel.js';
import HealthboostCarousel from './components/HealthboostCarousel.js';
import { BILLING } from '../../../../constants/routes.js';
import { Oval } from 'react-loader-spinner';
import { showMessage } from '../../../../config.js';
import { useState } from 'react';
import ReportCard from '../NewDashboard/ReportCard.js';

const FreeDashboard = ({
    user, company, permissionLevel, setTab, setIsViewTwoMinuteReport, isGenerateAllResearchAid, fitInvestorFirms, investorFirmCounts,
    checklistModules, sortModules, portfolioProReports, extensionPackages,
    showExtraModules, proPlusPacks, getFitInvestorFirms,
    handleSeeMore, handleHowItWorks, setModuleTab, moduleBox,
    handleRegisterNow, MODULE_NEW_DASHBOARD, MODULE_BOX, setCompanyDashboardTab, healthboostBox
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const subscription = company['subscription'] || 'Lite';
    let [isSwotReport, setIsSwotReport] = useState(false);

    const handleReportRedirect = (report) => {
        // CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD')) {
            showMessage(`You have ${permissionLevel} access only!`);
            return;
        };
        setTab(`${report['_id']}?${report['reportType']}-researchaid`);
        setCompanyDashboardTab('Dashboard');
    };

    useEffect(() => {
        if (fitInvestorFirms.length == 0) getFitInvestorFirms(false)
    }, [])

    const handleReportName = (report) => {
        if (report['reportType'] == 'swotAnalysis') {
            if (report?.['disableSwotReport']) setIsSwotReport(true);
            else setIsSwotReport(false);
            dispatch(toggleModal({ open: 'swotReportPopup' }));
        }
    };

    const reportCard = (report, type, item) => (
        <ReportCard
            report={report}
            type={type}
            item={item}
            company={company}
            user={user}
            permissionLevel={permissionLevel}
            onReportRedirect={handleReportRedirect}
            onReportName={handleReportName}
            onDeleteHistoryRecord={undefined}
            isGenerateAllResearchAid={isGenerateAllResearchAid}
        />
    );

    return (
        <div className="box-dashbord-contaxiner mla mra mb6rem mt2rem" style={{ width: '98%' }}>
            {/* Free */}
            {/* Portfolio Pro */}
            {/* {(user['role'] == 'Advisor' || user['role'] == 'Investor') && portfolioProReports()} */}
            <div className={`bg20 bss bo5 bsbb px2rem py2rem br25px w100 ${user?.['role'] == 'Guest' ? 'bo3' : 'bo28'} keyfeature-box keyfeature-box-company-${subscription.toLowerCase()} df fww mb2rem pr bsbb bw1px`} style={{ backgroundColor: '#EEFFF7' }}>
                <div className="df jcsb w100 aic">
                    <SectionTitle title="Some Easy Wins" subtitle="FREE" />
                </div>

                <div className='dg gg1rem gtcr4 w100'>
                    {/* KPI Report */}
                    <CoreWorkspaceButton permissionLevel={permissionLevel} user={user} company={company} setIsViewTwoMinuteReport={setIsViewTwoMinuteReport} step="2" title="KPI Report" type="kpi-report" module={{ ...company.modules["two-minute-test-" + company.testType], menus: ['howItWorks', 'seeMore'] }} setTab={setTab} handleSeeMore={handleSeeMore} handleHowItWorks={handleHowItWorks} seeMore={MODULE_NEW_DASHBOARD[company['testType']]?.['letsOrganise']?.['kpi']?.['seeMore']} howItWorks={MODULE_NEW_DASHBOARD[company['testType']]?.['letsOrganise']?.['kpi']?.['howItWorks']} setModuleTab={setModuleTab} isReady={true} subscription={"Free"} />

                    {company['testType'] == 'growth'
                        ? (<>
                            {/* Two Minute Test */}
                            {/* <CoreWorkspaceButton permissionLevel={permissionLevel} user={user} company={company} step="1" moduleCertification={company?.moduleCertification?.['two-minute-test-' + company['testType']]} title={<>{`${company.testType}`} <br></br> Readiness</>} type={"two-minute-test-" + company.testType} module={company.modules["two-minute-test-" + company.testType]} setTab={setTab} handleSeeMore={handleSeeMore} handleHowItWorks={handleHowItWorks} seeMore={MODULE_NEW_DASHBOARD[company['testType']]['letsOrganise']['two-minute-test']['seeMore']} howItWorks={MODULE_NEW_DASHBOARD[company['testType']]['letsOrganise']['two-minute-test']['howItWorks']} setModuleTab={setModuleTab} subscription={"Free"} time={"10 mins"} information={"Check your exit readiness - recommendations to increase your valuation on exit"} isBuy={true} price={"100"} /> */}
                        </>)
                        : company['testType'] == 'investment'
                            ? <>
                                {/* InvestorMatch */}
                                <CoreWorkspaceButton key='DEPF008' permissionLevel={permissionLevel} company={company} title='InvestorMatch' type='investor-lead' moduleCertification={company?.['moduleCertification']?.['investor-lead']} module={{
                                    ...company['modules']['investor-lead'],
                                    menus: ['listOfSections', 'report']
                                }} setTab={setTab} getFitInvestorFirms={getFitInvestorFirms} handleSeeMore={handleSeeMore} handleHowItWorks={handleHowItWorks} seeMore={MODULE_BOX['appStoreInvestment']['investor-leads']['seeMore']} howItWorks={MODULE_BOX['appStoreInvestment']['investor-leads']['howItWorks']} setModuleTab={setModuleTab} fitInvestorFirms={fitInvestorFirms} />

                                {/* Top 10 Investment Readiness Cock Ups To Avoid */}
                                {(company?.['modules'] && Object.values(company['modules']).length > 0) && checklistModules(Object.values(company['modules']).filter(item => {
                                    return (item?.['type'] == 'Top 10 Investment Readiness Cock Ups To Avoid' && item?.['category'] == "all" && item['isActive'] && !item['isHealthBoost'])
                                }).sort(sortModules).map(module => ({ ...module, menus: module?.menus || ['listOfSections', 'seeMore', 'howItWorks', 'report', 'workflow'] })))}

                                {/* Investment Readiness */}
                                {(company?.['modules'] && Object.values(company['modules']).length > 0) && checklistModules(Object.values(company['modules']).filter(item => {
                                    return (item?.['category'] == "partner" && item?.['testType'] == 'investment' && item['isActive'] && !item['isHealthBoost'])
                                }).sort(sortModules).map(module => ({ ...module, menus: module?.menus || ['listOfSections', 'seeMore', 'howItWorks', 'report', 'workflow'] })))}

                                {/* Generate Investment Readiness Module */}
                                {(company?.['modules'] && !company?.['modules']['Investment Readiness'] && company?.['extraModules']) && showExtraModules(company['extraModules'].filter(item => (item['testType'] == 'investment' && item['isActive'])))}

                                {/* Register Now */}
                                {user?.['role'] == 'Guest' && <Link to="/register" onClick={() => handleRegisterNow()}
                                    className={`pr bss ${user?.['role'] == 'Guest' ? 'bo3' : 'bo7'} bw3px btn-packge w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr bsbb register-btn`}>
                                    <div className='df aic'>
                                        <i className='icon-diligenstia mr1rem'>
                                            <img className="w40px h40px" src={require(`../../../../../images/advisor-dashboard/logo-advisor.svg`)} alt="" />
                                        </i>
                                        <p className='fs1rem fw500 c15 lh2 title-box-feature tal'> Register Now
                                            <span className='db w100 tal fw500 fs0-5rem'>Register your company email FREE now (no credit card required) to preserve your dashboard and access your reports</span>
                                        </p>
                                    </div>
                                    <Link to="/register" onClick={() => handleRegisterNow()} className='cp registerButtonAnimation'>Register Now</Link>
                                    <span className='step-box'>Step 4</span>
                                </Link>
                                }</>
                            : company['testType'] == 'exit'
                                ? <>
                                    {/* Two Minute Test */}
                                    {/* <CoreWorkspaceButton permissionLevel={permissionLevel} user={user} company={company} step="1" moduleCertification={company?.moduleCertification?.['two-minute-test-' + company['testType']]} title={company.testType + " Ready Test"} type={"two-minute-test-" + company.testType} module={company.modules["two-minute-test-" + company.testType]} setTab={setTab} handleSeeMore={handleSeeMore} handleHowItWorks={handleHowItWorks} seeMore={MODULE_NEW_DASHBOARD[company['testType']]['letsOrganise']['two-minute-test']['seeMore']} howItWorks={MODULE_NEW_DASHBOARD[company['testType']]['letsOrganise']['two-minute-test']['howItWorks']} setModuleTab={setModuleTab} /> */}

                                    {/* Top 10 Investment Readiness Cock Ups To Avoid */}
                                    {(company?.['modules'] && Object.values(company['modules']).length > 0) && checklistModules(Object.values(company['modules']).filter(item => {
                                        return (item?.['type'] == 'Top 10 Investment Readiness Cock Ups To Avoid' && item?.['category'] == "all" && item['isActive'] && !item['isHealthBoost'])
                                    }).sort(sortModules).map(module => ({ ...module, menus: module?.menus || ['listOfSections', 'seeMore', 'howItWorks', 'report', 'workflow'] })))}

                                    {/* Register Now */}
                                    {user?.['role'] == 'Guest' && <Link to="/register" onClick={() => handleRegisterNow()}
                                        className={`pr bss ${user?.['role'] == 'Guest' ? 'bo3' : 'bo7'} bw3px btn-packge w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr bsbb register-btn`}>
                                        <div className='df aic'>
                                            <i className='icon-diligenstia mr1rem'>
                                                <img className="w40px h40px" src={require(`../../../../../images/advisor-dashboard/logo-advisor.svg`)} alt="" />
                                            </i>
                                            <p className='fs1rem fw500 c15 lh2 title-box-feature tal'> Register Now
                                                <span className='db w100 tal fw500 fs0-5rem'>Register your company email FREE now (no credit card required) to preserve your dashboard and access your reports</span>
                                            </p>
                                        </div>
                                        <Link to="/register" onClick={() => handleRegisterNow()} className='cp registerButtonAnimation'>Register Now</Link>
                                        <span className='step-box'>Step 4</span>
                                    </Link>
                                    }
                                </>
                                : null
                    }
                </div>

                {/* AI Icon */}
                <div className='right-img-areas df w100 aic jcfe' style={{ margin: '-58px 0' }}>
                    {user['role'] == 'Guest'
                        ? <img className="w30 mt2rem pr" style={{ right: '-52px' }} src={require(`../../../../../images/register-ai-left-img.png`)} alt="aiIcon" />
                        : company?.moduleStats && company?.moduleStats["two-minute-test-" + company.testType]?.['stats']?.['completionPercent'] == 100
                            ? <img className="w30 mt2rem pr" style={{ right: '-52px' }} src={require(`../../../../../images/completed2minutetest.png`)} alt="aiIcon" />
                            : null
                    }
                </div>
            </div>
            {/* Lite */}
            {MODULE_NEW_DASHBOARD[company['testType']]?.['letsOrganise']
                ? <div className="bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 bo28 bw1px">
                    <div className="grs1-md gre3-md df fdc aifs tac" style={{ width: '21%' }}>
                        <div className='df fdc aifs tac'>
                            <h3 className="fs1-25re c15 w100 tal">Now let’s get organised</h3>
                            {subscription == 'Free' && (<h3 className='fs1rem c59 tal w100'>{user['role'] == 'Advisor' ? 'PRO only' : 'LITE & PRO only'}</h3>)}
                            {subscription !== 'Pro' && (
                                <Button
                                    text={<p className='fs0-75rem c1'>{subscription === 'Lite' ? 'Unlock Pro' : 'Upgrade to start'}</p>}
                                    onClick={() => {
                                        const userRole = user?.role?.toLowerCase();
                                        const servicedRole = company?.servicedBy?.role?.toLowerCase();
                                        const companyId = company?._id;
                                        const isSpecialRole = ['advisor', 'investor'].includes(userRole) || ['advisor', 'investor'].includes(servicedRole) || user?.['createdBy']?.['role']?.toLowerCase() == 'investor' || user?.['createdBy']?.['role']?.toLowerCase() == 'advisor';

                                        if (isSpecialRole) {
                                            navigate(`/billing/${companyId}/pro/${servicedRole}`);
                                        } else {
                                            navigate(BILLING.replace(':id', companyId));
                                        }
                                    }}
                                    btnType="warning"
                                    style={{ padding: '0.5rem 1.5rem' }}
                                    customClassName='mt0-5rem'
                                />
                            )}
                        </div>
                        <div className='df jcc aic w100 h100'>
                            <img onClick={() => dispatch(toggleModal({ open: 'whatYouGetModal' }))} src={require(`../../../../../images/dashboard/diligencePack.svg`)} style={{ width: '230px', height: '251px' }} alt="dashboardIcon" />
                        </div>
                    </div>
                    <div className='dg gg1rem gtcr3 fww coreworkspace-update' style={{ width: '75%' }}>
                        {(() => {
                            const items = Object.values(MODULE_NEW_DASHBOARD[company['testType']]?.['letsOrganise'] || {}).filter(item => item['title']);
                            if (company['subscription'] !== 'Lite') {
                                return items.map((item, idx) => moduleBox(item))
                            }
                            let firstTwoItems = items.slice(0, 2);
                            let remainingItems = items.slice(2);

                            return (
                                <>
                                    {/* Single green-bordered container for first two cards */}
                                    {firstTwoItems.length > 0 && !['Free', 'Pro'].includes(company['subscription']) && (
                                        <div
                                            key="first-two-container"
                                            style={{
                                                gridColumn: 'span 2',
                                                backgroundColor: '#EEFFF7',
                                                borderRadius: '15px',
                                                padding: '16px 16px 12px',
                                                border: '1px solid rgba(115, 133, 190, 0.5)',
                                                display: 'grid',
                                                gridTemplateColumns: '1fr 1fr',
                                                gap: '1rem'
                                            }}
                                        >
                                            {firstTwoItems.map((item, idx) => moduleBox(item))}
                                        </div>
                                    )}
                                    {/* Remaining cards */}
                                    {remainingItems.map((item, idx) => moduleBox(item))}
                                </>
                            );
                        })()}
                    </div>
                </div>
                : null}

            {MODULE_NEW_DASHBOARD[company['testType']]?.['proveOurValue']
                ? <div className="bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 bo28 bw1px">
                    <div className="grs1-md gre3-md df fdc aifs tac" style={{ width: '21%' }}>
                        <div className='df fdc aifs tal'>
                            <h3 className="fs1-25re c15 w100 tal">Prove our value...</h3>
                            <p className='fs1rem c59 tal w100'>PRO only</p>
                        </div>
                        <div className='df jcc aic w100 h100'>
                            <img src={require(`../../../../../images/dashboard/researchAidReport.svg`)} style={{ width: '230px', height: '251px' }} alt="dashboardIcon" />
                        </div>
                    </div>
                    <div className='dg gg1rem gtcr3 fww coreworkspace-update' style={{ width: '75%' }}>
                        {Object.values(MODULE_NEW_DASHBOARD[company['testType']]?.['proveOurValue'] || {}).map(item => item?.module ? reportCard(item?.['module'], item?.['isReseachAid']?.['type'], item) : moduleBox(item))}
                    </div>
                </div>
                : null}

            {MODULE_NEW_DASHBOARD[company['testType']]?.['getPitching']
                ? <div className="bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 bo28 bw1px">
                    <div className="grs1-md gre3-md df fdc aifs tac" style={{ width: '21%' }}>
                        <div className='df fdc aifs tal'>
                            <h3 className="fs1-25re c15 w100 tal">.. and get pitching!</h3>
                            <p className='fs1rem c59 tal w100'>PRO only</p>
                        </div>

                        <div className='df jcc aic w100 h100'>
                            <img src={require(`../../../../../images/dashboard/getPitching.svg`)} style={{ width: '230px', height: '251px' }} alt="dashboardIcon" />
                        </div>
                    </div>
                    <div className='dg gg1rem gtcr3 fww coreworkspace-update' style={{ width: '75%' }}>
                        {Object.values(MODULE_NEW_DASHBOARD[company['testType']]?.['getPitching'] || {}).map(item => item['title'] && moduleBox(item))}</div>
                </div>
                : null
            }

            {MODULE_NEW_DASHBOARD[company['testType']]?.['turboBoost']
                ? <div className="bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-pro df jcsb fww mb2rem pr bsbb bw2 bo28 bw1px">

                    <div className="grs1-md gre3-md df fdc aifs tac" style={{ width: '21%' }}>
                        <div className='df fdc aifs tal'>
                            <h3 className="fs1-25re c15 w100 tal">.. and turbo boost your growth!</h3>
                            <p className='fs1rem c59 tal w100'>PRO only</p>
                        </div>

                        <div className='df jcc aic w100 h100'>
                            <img src={require(`../../../../../images/dashboard/healthboost.svg`)} style={{ width: '230px', height: '251px' }} alt="dashboardIcon" />
                        </div>
                    </div>
                    <div className="healthboost-carousel-container" style={{ width: '75%', position: 'relative' }}>
                        <HealthboostCarousel
                            items={(() => {
                                // Get actual company healthBoost modules
                                if (company?.['modules'] && Object.values(company['modules']).length > 0) {
                                    return Object.values(company['modules'])
                                        .filter(item => (item?.['category'] == "all" && item?.['isHealthBoost']))
                                        .sort(sortModules)
                                        .map(item => ({
                                            ...(MODULE_NEW_DASHBOARD[company['testType']]?.['turboBoost']?.[item['type']] || { un: "true" }),
                                            ...item,
                                        }));
                                }
                                return [];
                            })()}
                            healthboostBox={healthboostBox}
                        />
                    </div>
                </div>
                : null
            }

            <div className="bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 bo28 bw1px">
                <div className="grs1-md gre3-md df fdc aifs tac" style={{ width: '21%' }}>
                    <div className='df fdc aifs tal'>
                        <h3 className="fs1-25re c15 w100 tal">Need advisor assistance?</h3>
                        <p className='fs1rem c59 tal w100'>Diligentsia Plus</p>
                    </div>

                    <div className='df jcc aic w100 h100'>
                        <img src={require(`../../../../../images/dashboard/advisorAssistant.svg`)} style={{ width: '230px', height: '251px' }} alt="dashboardIcon" />
                    </div>
                </div>
                {/* card carousel */}
                <div className="advisor-carousel-container" style={{ width: '75%', position: 'relative' }}>
                    <AdvisorCarousel setCompanyDashboardTab={setCompanyDashboardTab} />
                </div>
            </div>
        </div>
    );
};

export default FreeDashboard;